const ParamListGen = (model) => {
  if (model) {
    let finalModel = [];
    const allKeys = Object.keys(model);
    allKeys.forEach((key) => {
      if (model[key]) finalModel.push({ key, value: model[key] });
    });
    return finalModel;
  } else {
    return {};
  }
};
export default ParamListGen;
